import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-auto-enquiry-log',
  templateUrl: './auto-enquiry-log.component.html',
  styleUrls: ['./auto-enquiry-log.component.scss']
})
export class AutoEnquiryLogComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_data_available: boolean = true;
  enquiry_log_data: any = [];
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.is_data_available = false;
    this.httpService.serveAutoEnquiryLog(data_dict).subscribe((data) => {
      console.log(data);
      this.enquiry_log_data = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  ngOnInit() {
  }

}
